define(['jquery', "vacancyfilter", "togglehandler", "singleselect"], function ($, vacancyfilter, togglehandler, singleselect) {
    var vacanciesPage = {

        initVacancyFilter: function (args) {
            vacancyfilter.init(...args)
        },

        initSingleSelect: function () {
            singleselect.init();
        },

        initExandableArea: function (expandablePanelSelector, togglerSelector, isOpenClass, uninitializedClass) {

            var $toggler = $(togglerSelector);
            var $expandablePanel = $(expandablePanelSelector);

            /*
             * In order to support different initial open / close behaviours in mobile / desktop
             * the 'source' for if the area is expanded or not is in css.By using an initial
             * "uninitialized" class we can style the initial behaviour.
             *
             * Before calling initToggler() we then read the "uninitialized" default style and
             * set up script- related attributes such as css class "is-open" and aria attribute
             * aria - expanded.We also remove the "uninitialized" class so as not to interfere
             * with normal functionality and styles.
             *
             * By adding script - related cssclasses and aria - attributes here, by script, instead
             * of initial markup also allows us to more easily apply non - script appearance.
             */
            var isPanelVisible = $expandablePanel.height() > 0;
            if (isPanelVisible) {
                $expandablePanel.addClass(isOpenClass);
                $toggler.addClass(isOpenClass);
            }
            $toggler.attr("aria-expanded", isPanelVisible);
            $(expandablePanelSelector + ", " + togglerSelector).removeClass(uninitializedClass);

            togglehandler.initToggler(
                {
                    triggerSelectors: [togglerSelector],
                    targetContainerSelector: ".js-accentedexpandable-container",
                    targetSelectors: [expandablePanelSelector],
                    toggleClass: isOpenClass,
                    ariaExpandedSelectors: [togglerSelector]
                }
            );
        }
    };
    return vacanciesPage;
});

